import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Panel from 'components/common/panel/panel';
import Heading from 'components/common/heading/heading';
import useForm from 'hooks/form';

export default function FormTestPage(props) {
  return (
    <>
      <Heading>
        <div>
          <a href='/Developers/Test/Components' className='btn btn-link'>View Components Test</a>
          <a href='/Developers/Test/Data' className='btn btn-link'>View Data Test</a>
          <div className='btn btn-none text-dark text-thick'>Forms Test</div>
          <a href='/Developers/Test/Modals' className='btn btn-link'>View Modals Test</a>
        </div>
      </Heading>

      <div className='row justify-content-center mx-0 mt-4'>
        <div className='col-md-10 col-lg-9 col-xl-7'>

          <NormalFormTest />

          <Panel>
            <Panel.Header>Disabled Forms</Panel.Header>
            <Panel.Body>
              <Form.Group>
                <Form.Label>Plaintext</Form.Label>
                <Inputs.Plaintext value='Plaintext One' />
                <Inputs.Plaintext>Plaintext Two</Inputs.Plaintext>
              </Form.Group>
              <Form.Group>
                <Form.Label>Text</Form.Label>
                <Inputs.Text placeholder='Text Input' value='Text' disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Integer</Form.Label>
                <Inputs.Integer placeholder='Integer Input' value='123' disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Float</Form.Label>
                <Inputs.Float placeholder='Float Input' value='12.3' disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Inputs.Email placeholder='Email Input' value='email@email.text' disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Throttled</Form.Label>
                <Inputs.Text.Throttled placeholder='Throttled Input' value='Throttled' onValueChange={() => alert('change')} disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Area</Form.Label>
                <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} disabled />
                <div className='mt-1'></div>
                <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} rows='8' disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Select</Form.Label>
                <Inputs.Select placeholder='Select Input' value='1' disabled>
                  <Inputs.Option value='1' label='One' />
                  <Inputs.Option value='2'>Two</Inputs.Option>
                  <Inputs.Select.Option value='3' label='Three' />
                  <Inputs.Select.Option value='4'>Four</Inputs.Select.Option>
                  <Inputs.OptionGroup label='Group One'>
                    <Inputs.Option value='5' label='Five' />
                    <Inputs.Option value='6'>Six</Inputs.Option>
                  </Inputs.OptionGroup>
                  <Inputs.Option.Group label='Group Two'>
                    <Inputs.Option value='7' label='Seven' />
                    <Inputs.Option value='8'>Eight</Inputs.Option>
                  </Inputs.Option.Group>
                  <Inputs.Select.Option.Group label='Group Three'>
                    <Inputs.Option value='9' label='Nine' />
                    <Inputs.Option value='10'>Ten</Inputs.Option>
                  </Inputs.Select.Option.Group>
                </Inputs.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label>Date</Form.Label>
                <Inputs.Date placeholder='Date Input' value={new Date()} disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Date &amp; Time</Form.Label>
                <Inputs.DateTime placeholder='Date Time Input' value={new Date()} disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Time</Form.Label>
                <Inputs.Time placeholder='Time Input' value={new Date()} disabled />
              </Form.Group>
              <Form.Group>
                <Form.Label>Checkbox</Form.Label>
                <div>
                  <Inputs.Checkbox label='Checkbox' checked={true} disabled />
                  <Inputs.Checkbox label='Checkbox' indeterminate={true} disabled />
                  <Inputs.Checkbox label='Checkbox' checked={false} disabled />
                </div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Radio</Form.Label>
                <div>
                  <Inputs.RadioGroup value='2'>
                    <Inputs.Radio label='Radio' checked={true} value='1' disabled />
                    <Inputs.Radio label='Radio' checked={false} value='2' disabled />
                    <Inputs.Radio label='Radio' checked={false} value='3' disabled />
                  </Inputs.RadioGroup>
                </div>
              </Form.Group>
            </Panel.Body>
          </Panel>

          <InvalidFormTest />

          <ValidFormTest />

          <Panel>
            <Panel.Header>Help Forms</Panel.Header>
            <Panel.Body>
              <Form>
                <Form.Group>
                  <Form.Label>Plaintext</Form.Label>
                  <Inputs.Plaintext value='Plaintext One' help='Plaintext' />
                  <Inputs.Plaintext>Plaintext Two</Inputs.Plaintext>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Text</Form.Label>
                  <Inputs.Text placeholder='Text Input' help='Text' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Integer</Form.Label>
                  <Inputs.Integer placeholder='Integer Input' help='Integer' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Float</Form.Label>
                  <Inputs.Float placeholder='Float Input' help='Float' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Inputs.Email placeholder='Email Input' help='Email' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Throttled</Form.Label>
                  <Inputs.Text.Throttled placeholder='Throttled Input' onValueChange={() => alert('change')} help='Throttled' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Area</Form.Label>
                  <Inputs.TextArea placeholder='Text Area Input' help='Area' />
                  <div className='mt-1'></div>
                  <Inputs.TextArea placeholder='Text Area Input' rows='8' help='Area' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Select</Form.Label>
                  <Inputs.Select placeholder='Select Input' help='Select'>
                    <Inputs.Option value='1' label='One' />
                    <Inputs.Option value='2'>Two</Inputs.Option>
                    <Inputs.Select.Option value='3' label='Three' />
                    <Inputs.Select.Option value='4'>Four</Inputs.Select.Option>
                    <Inputs.OptionGroup label='Group One'>
                      <Inputs.Option value='5' label='Five' />
                      <Inputs.Option value='6'>Six</Inputs.Option>
                    </Inputs.OptionGroup>
                    <Inputs.Option.Group label='Group Two'>
                      <Inputs.Option value='7' label='Seven' />
                      <Inputs.Option value='8'>Eight</Inputs.Option>
                    </Inputs.Option.Group>
                    <Inputs.Select.Option.Group label='Group Three'>
                      <Inputs.Option value='9' label='Nine' />
                      <Inputs.Option value='10'>Ten</Inputs.Option>
                    </Inputs.Select.Option.Group>
                  </Inputs.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Date</Form.Label>
                  <Inputs.Date placeholder='Date Input' help='Date' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Date &amp; Time</Form.Label>
                  <Inputs.DateTime placeholder='Date Time Input' help='Date Time' />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Time</Form.Label>
                  <Inputs.Time placeholder='Time Input' help='Time' />
                </Form.Group>
              </Form>
            </Panel.Body>
          </Panel>

          <Panel>
            <Panel.Header>Input Group Forms</Panel.Header>
            <Panel.Body>
              <Form>
                <Form.Group>
                  <Form.Label>Plaintext</Form.Label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                    <Inputs.Plaintext value='Plaintext One' />
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <Inputs.Plaintext value='Plaintext Two' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                    </div>
                    <Inputs.Plaintext value='Plaintext Three' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Text</Form.Label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                    <Inputs.Text placeholder='Text Input' />
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <Inputs.Text placeholder='Text Input' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <Inputs.Text placeholder='Text Input' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='warning' iconClass='icons8-pause' />
                      <Inputs.Button variant='danger' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                    </div>
                    <Inputs.Text placeholder='Text Input' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>https://webaddress.com/</div>
                    </div>
                    <Inputs.Text placeholder='Text Input' />
                    <div className='input-group-append'>
                      <div className='input-group-text'>/index.html</div>
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'><Inputs.Checkbox /></div>
                    </div>
                    <Inputs.Text placeholder='Text Input' />
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Area</Form.Label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                    <Inputs.TextArea placeholder='Text Area Input' rows='5' />
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <Inputs.TextArea placeholder='Text Area Input' rows='5' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                    </div>
                    <Inputs.TextArea placeholder='Text Area Input' rows='5' />
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>https://webaddress.com/</div>
                    </div>
                    <Inputs.TextArea placeholder='Text Area Input' rows='5' />
                    <div className='input-group-append'>
                      <div className='input-group-text'>/index.html</div>
                    </div>
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Select</Form.Label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                    <Inputs.Select placeholder='Select Input'>
                      <Inputs.Option value='1' label='One' />
                      <Inputs.Option value='2'>Two</Inputs.Option>
                    </Inputs.Select>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <Inputs.Select placeholder='Select Input'>
                      <Inputs.Option value='1' label='One' />
                      <Inputs.Option value='2'>Two</Inputs.Option>
                    </Inputs.Select>
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <Inputs.Button variant='form' iconClass='icons8-pause' />
                    </div>
                    <Inputs.Select placeholder='Select Input'>
                      <Inputs.Option value='1' label='One' />
                      <Inputs.Option value='2'>Two</Inputs.Option>
                    </Inputs.Select>
                    <div className='input-group-append'>
                      <Inputs.Button variant='form' iconClass='icons8-stop' />
                    </div>
                  </div>
                  <div className='mt-1'></div>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>https://webaddress.com/</div>
                    </div>
                    <Inputs.Select placeholder='Select Input'>
                      <Inputs.Option value='1' label='One' />
                      <Inputs.Option value='2'>Two</Inputs.Option>
                    </Inputs.Select>
                    <div className='input-group-append'>
                      <div className='input-group-text'>/index.html</div>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </Panel.Body>
          </Panel>

          <div>
            TODO
            <ol>

            </ol>
          </div>

        </div>
      </div>
    </>
  );
}

function NormalFormTest() {
  const { setFormRef, submitForm, renderFormValidationMessage } = useForm();

  const [message, setMessage] = useState();

  const handleSubmit = submitForm(
    () => {
      setMessage(<div className='mb-2'>Success!</div>)
    },
    () => {
      setMessage(<div className='mb-2'>Invalid</div>)
    }
  );

  return (
    <Form ref={setFormRef} noValidate>
      <Panel>
        <Panel.Header>Normal Forms</Panel.Header>
        <Panel.Body>
          <Form.Group>
            <Form.Label>Plaintext</Form.Label>
            <Inputs.Plaintext value='Plaintext One' />
            <Inputs.Plaintext>Plaintext Two</Inputs.Plaintext>
          </Form.Group>
          <Form.Group>
            <Form.Label>Text</Form.Label>
            <Inputs.Text placeholder='Text Input' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Integer</Form.Label>
            <Inputs.Integer placeholder='Integer Input' min='1' max='9999' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Float</Form.Label>
            <Inputs.Float placeholder='Float Input' min='0' max='9999.999' precision={3} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Inputs.Email placeholder='Email Input' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Throttled</Form.Label>
            <Inputs.Text.Throttled placeholder='Throttled Input' onValueChange={() => alert('change')} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Area</Form.Label>
            <Inputs.TextArea placeholder='Text Area Input' />
            <div className='mt-1'></div>
            <Inputs.TextArea placeholder='Text Area Input' rows='8' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Select</Form.Label>
            <Inputs.Select placeholder='Select Input'>
              <Inputs.Option value='1' label='One' />
              <Inputs.Option value='2'>Two</Inputs.Option>
              <Inputs.Select.Option value='3' label='Three' />
              <Inputs.Select.Option value='4'>Four</Inputs.Select.Option>
              <Inputs.OptionGroup label='Group One'>
                <Inputs.Option value='5' label='Five' />
                <Inputs.Option value='6'>Six</Inputs.Option>
              </Inputs.OptionGroup>
              <Inputs.Option.Group label='Group Two'>
                <Inputs.Option value='7' label='Seven' />
                <Inputs.Option value='8'>Eight</Inputs.Option>
              </Inputs.Option.Group>
              <Inputs.Select.Option.Group label='Group Three'>
                <Inputs.Option value='9' label='Nine' />
                <Inputs.Option value='10'>Ten</Inputs.Option>
              </Inputs.Select.Option.Group>
            </Inputs.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Inputs.Date placeholder='Date Input' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date &amp; Time</Form.Label>
            <Inputs.DateTime placeholder='Date Time Input' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Time</Form.Label>
            <Inputs.Time placeholder='Time Input' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Checkbox</Form.Label>
            <div>
              <Inputs.Checkbox label='Checkbox' checked={true} />
              <Inputs.Checkbox label='Checkbox' indeterminate={true} />
              <Inputs.Checkbox label='Checkbox' checked={false} />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Radio</Form.Label>
            <div>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Radio' checked={true} value='1' />
                <Inputs.Radio label='Radio' checked={false} value='2' />
                <Inputs.Radio label='Radio' checked={false} value='3' />
              </Inputs.RadioGroup>
            </div>
          </Form.Group>
        </Panel.Body>
        <Panel.Footer>
          {renderFormValidationMessage()}
          {message}
          <Inputs.Button variant='success' label='Submit' onClick={handleSubmit} />
        </Panel.Footer>
      </Panel>
    </Form>
  );
}

function InvalidFormTest() {
  const { setFormRef, submitForm, renderFormValidationMessage } = useForm();

  const [message, setMessage] = useState();

  const handleSubmit = submitForm(
    () => {
      setMessage(<div className='mb-2'>Success!</div>)
    },
    () => {
      setMessage(<div className='mb-2'>Invalid</div>)
    }
  );

  return (
    <Form ref={setFormRef} noValidate>
      <Panel>
        <Panel.Header>Invalid Forms</Panel.Header>
        <Panel.Body>
          <Form.Group>
            <Form.Label>Plaintext</Form.Label>
            <Inputs.Plaintext value='Plaintext One' />
            <Inputs.Plaintext>Plaintext Two</Inputs.Plaintext>
          </Form.Group>
          <Form.Group>
            <Form.Label>Text</Form.Label>
            <Inputs.Text placeholder='Text Input' value='Text' isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Integer</Form.Label>
            <Inputs.Integer placeholder='Integer Input' value='123' isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Float</Form.Label>
            <Inputs.Float placeholder='Float Input' value='12.3' isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Inputs.Email placeholder='Email Input' value='email@email.test' isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Throttled</Form.Label>
            <Inputs.Text.Throttled placeholder='Throttled Input' value='Throttled' onValueChange={() => alert('change')} isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Area</Form.Label>
            <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} isInvalid alwaysShowValidity feedback='Error' />
            <div className='mt-1'></div>
            <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} rows='8' isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Select</Form.Label>
            <Inputs.Select placeholder='Select Input' value='1' isInvalid alwaysShowValidity feedback='Error'>
              <Inputs.Option value='1' label='One' />
              <Inputs.Option value='2'>Two</Inputs.Option>
              <Inputs.Select.Option value='3' label='Three' />
              <Inputs.Select.Option value='4'>Four</Inputs.Select.Option>
              <Inputs.OptionGroup label='Group One'>
                <Inputs.Option value='5' label='Five' />
                <Inputs.Option value='6'>Six</Inputs.Option>
              </Inputs.OptionGroup>
              <Inputs.Option.Group label='Group Two'>
                <Inputs.Option value='7' label='Seven' />
                <Inputs.Option value='8'>Eight</Inputs.Option>
              </Inputs.Option.Group>
              <Inputs.Select.Option.Group label='Group Three'>
                <Inputs.Option value='9' label='Nine' />
                <Inputs.Option value='10'>Ten</Inputs.Option>
              </Inputs.Select.Option.Group>
            </Inputs.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Inputs.Date placeholder='Date Input' value={new Date()} isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date &amp; Time</Form.Label>
            <Inputs.DateTime placeholder='Date Time Input' value={new Date()} isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Time</Form.Label>
            <Inputs.Time placeholder='Time Input' value={new Date()} isInvalid alwaysShowValidity feedback='Error' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Checkbox</Form.Label>
            <div>
              <Inputs.Checkbox label='Checkbox' checked={true} isInvalid alwaysShowValidity feedback='Error' />
              <Inputs.Checkbox label='Checkbox' indeterminate={true} isInvalid alwaysShowValidity feedback='Error' />
              <Inputs.Checkbox label='Checkbox' checked={false} isInvalid alwaysShowValidity feedback='Error' />
            </div>
            <div className='mt-2'>
              <Inputs.Checkbox label='Checkbox' block checked={true} isInvalid alwaysShowValidity feedback='Error' />
              <Inputs.Checkbox label='Checkbox' block indeterminate={true} isInvalid alwaysShowValidity feedback='Error' />
              <Inputs.Checkbox label='Checkbox' block checked={false} isInvalid alwaysShowValidity feedback='Error' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Radio</Form.Label>
            <div>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Radio' checked={true} value='1' isInvalid alwaysShowValidity feedback='Error' />
                <Inputs.Radio label='Radio' checked={false} value='2' isInvalid alwaysShowValidity feedback='Error' />
                <Inputs.Radio label='Radio' checked={false} value='3' isInvalid alwaysShowValidity feedback='Error' />
              </Inputs.RadioGroup>
            </div>
            <div className='mt-2'>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Radio' block checked={true} value='1' isInvalid alwaysShowValidity feedback='Error' />
                <Inputs.Radio label='Radio' block checked={false} value='2' isInvalid alwaysShowValidity feedback='Error' />
                <Inputs.Radio label='Radio' block checked={false} value='3' isInvalid alwaysShowValidity feedback='Error' />
              </Inputs.RadioGroup>
            </div>
          </Form.Group>
        </Panel.Body>
        <Panel.Footer>
          {renderFormValidationMessage()}
          {message}
          <Inputs.Button variant='success' label='Submit' onClick={handleSubmit} />
        </Panel.Footer>
      </Panel>
    </Form>
  );
}

function ValidFormTest() {
  const { setFormRef, submitForm, renderFormValidationMessage } = useForm();

  const [message, setMessage] = useState();

  const handleSubmit = submitForm(
    () => {
      setMessage(<div className='mb-2'>Success!</div>)
    },
    () => {
      setMessage(<div className='mb-2'>Invalid</div>)
    }
  );

  return (
    <Form ref={setFormRef} noValidate>
      <Panel>
        <Panel.Header>Valid Forms</Panel.Header>
        <Panel.Body>
          <Form.Group>
            <Form.Label>Plaintext</Form.Label>
            <Inputs.Plaintext value='Plaintext One' />
            <Inputs.Plaintext>Plaintext Two</Inputs.Plaintext>
          </Form.Group>
          <Form.Group>
            <Form.Label>Text</Form.Label>
            <Inputs.Text placeholder='Text Input' value='Text' isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Integer</Form.Label>
            <Inputs.Integer placeholder='Integer Input' value='123' isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Float</Form.Label>
            <Inputs.Float placeholder='Float Input' value='12.3' isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Inputs.Email placeholder='Email Input' value='email@email.test' isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Throttled</Form.Label>
            <Inputs.Text.Throttled placeholder='Throttled Input' value='Throttled' onValueChange={() => alert('change')} isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Area</Form.Label>
            <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} isValid alwaysShowValidity feedback='Good' />
            <div className='mt-1'></div>
            <Inputs.TextArea placeholder='Text Area Input' value={multiLineText} rows='8' isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Select</Form.Label>
            <Inputs.Select placeholder='Select Input' value='1' isValid alwaysShowValidity feedback='Good'>
              <Inputs.Option value='1' label='One' />
              <Inputs.Option value='2'>Two</Inputs.Option>
              <Inputs.Select.Option value='3' label='Three' />
              <Inputs.Select.Option value='4'>Four</Inputs.Select.Option>
              <Inputs.OptionGroup label='Group One'>
                <Inputs.Option value='5' label='Five' />
                <Inputs.Option value='6'>Six</Inputs.Option>
              </Inputs.OptionGroup>
              <Inputs.Option.Group label='Group Two'>
                <Inputs.Option value='7' label='Seven' />
                <Inputs.Option value='8'>Eight</Inputs.Option>
              </Inputs.Option.Group>
              <Inputs.Select.Option.Group label='Group Three'>
                <Inputs.Option value='9' label='Nine' />
                <Inputs.Option value='10'>Ten</Inputs.Option>
              </Inputs.Select.Option.Group>
            </Inputs.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Date</Form.Label>
            <Inputs.Date placeholder='Date Input' value={new Date()} isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Date &amp; Time</Form.Label>
            <Inputs.DateTime placeholder='Date Time Input' value={new Date()} isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Time</Form.Label>
            <Inputs.Time placeholder='Time Input' value={new Date()} isValid alwaysShowValidity feedback='Good' />
          </Form.Group>
          <Form.Group>
            <Form.Label>Checkbox</Form.Label>
            <div>
              <Inputs.Checkbox label='Checkbox' checked={true} isValid alwaysShowValidity feedback='Good' />
              <Inputs.Checkbox label='Checkbox' indeterminate={true} isValid alwaysShowValidity feedback='Good' />
              <Inputs.Checkbox label='Checkbox' checked={false} isValid alwaysShowValidity feedback='Good' />
            </div>
            <div className='mt-2'>
              <Inputs.Checkbox label='Checkbox' block checked={true} isValid alwaysShowValidity feedback='Good' />
              <Inputs.Checkbox label='Checkbox' block indeterminate={true} isValid alwaysShowValidity feedback='Good' />
              <Inputs.Checkbox label='Checkbox' block checked={false} isValid alwaysShowValidity feedback='Good' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Radio</Form.Label>
            <div>
              <Inputs.RadioGroup value='2'>
                <Inputs.Radio label='Radio' checked={true} value='1' isValid alwaysShowValidity feedback='Good' />
                <Inputs.Radio label='Radio' checked={false} value='2' isValid alwaysShowValidity feedback='Good' />
                <Inputs.Radio label='Radio' checked={false} value='3' isValid alwaysShowValidity feedback='Good' />
              </Inputs.RadioGroup>
              <div className='mt-2'>
                <Inputs.RadioGroup value='2'>
                  <Inputs.Radio label='Radio' block checked={true} value='1' isValid alwaysShowValidity feedback='Good' />
                  <Inputs.Radio label='Radio' block checked={false} value='2' isValid alwaysShowValidity feedback='Good' />
                  <Inputs.Radio label='Radio' block checked={false} value='3' isValid alwaysShowValidity feedback='Good' />
                </Inputs.RadioGroup>
              </div>
            </div>
          </Form.Group>
        </Panel.Body>
        <Panel.Footer>
          {renderFormValidationMessage()}
          {message}
          <Inputs.Button variant='success' label='Submit' onClick={handleSubmit} />
        </Panel.Footer>
      </Panel>
    </Form>
  );
}

const multiLineText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
Praesent a nibh sed odio suscipit varius vitae nec tellus.
Duis maximus orci vel augue fermentum accumsan.
Vivamus a nisi iaculis, tempor felis in, finibus erat.
Morbi sit amet urna et diam eleifend mollis.
Nam commodo lorem vel tristique facilisis.
Curabitur suscipit mauris sit amet felis rutrum, a commodo dui vulputate.
Pellentesque sed diam a lorem placerat vehicula.
In egestas purus in aliquam venenatis.
Nunc vel nibh consequat, tempor mi ac, lacinia tortor.
Quisque sodales diam ac ligula venenatis, eu suscipit tortor imperdiet.
Curabitur egestas arcu et elit pharetra dignissim.
Pellentesque vel mi eget augue feugiat finibus et et justo.
Nam fringilla purus et sollicitudin aliquam.
Aenean viverra risus a urna interdum, quis tempus tortor hendrerit.
Duis mollis nibh vel tellus varius, non ornare nunc eleifend.
Proin nec justo vulputate, vestibulum sapien a, imperdiet lectus.
Integer eget sem feugiat, elementum nulla ac, sollicitudin enim.`;